import { Component } from '@angular/core';

@Component({
  selector: 'studio-dialog-buttons-container',
  templateUrl: './dialog-buttons-container.component.html',
  styleUrls: ['./dialog-buttons-container.component.scss'],
})
export class DialogButtonsContainerComponent {}
